<template>
  <div class="data-query-page">
    <!-- 页面标题 -->
    <el-header class="topbar">
      <div class="topbar-content">
        <!-- 左侧：主页按钮 -->
        <div class="topbar-left">
          <el-button type="text" class="home-btn" @click="goBack">
            <el-icon>
              <HomeFilled />
            </el-icon>
            <span class="home-text">首页</span>
          </el-button>
        </div>

        <!-- 标题 -->
        <div class="topbar-title">
          <span class="title-cn">OH 社区运营平台（管理员）</span>
        </div>

        <!-- 用户信息 -->
        <div class="topbar-right" v-if="user.name">
          <el-icon class="user-icon">
            <User />
          </el-icon>
          <span class="user-name">{{ user.name }}</span>
          <el-button type="text" class="logout-btn" @click="handleLogout">
            <el-icon>
              <SwitchButton />
            </el-icon>
            <span class="logout-text">退出</span>
          </el-button>
        </div>
        <div v-else class="topbar-right">
          <span class="user-name">加载中...</span>
        </div>
      </div>
    </el-header>

    <!-- 查询条件卡片 -->
    <el-card shadow="hover" class="form-card">
      <template #header>
        <span class="card-title">查询条件</span>
      </template>
      <el-form :model="queryForm" ref="queryFormRef" label-width="120px" class="query-form">
        <el-row :gutter="20">

          <el-col :span="6">
            <el-form-item label="用户名" prop="userName">
              <el-input v-model="queryForm.userName" placeholder="请输入" clearable></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="所属PMC" prop="PMC">
              <el-select v-model="queryForm.PMC" placeholder="请选择" clearable>
                <el-option v-for="(value, key) in PMCMap" :key="key" :label="value" :value="key"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="伙伴公司名称" prop="partnerName">
              <el-input v-model="queryForm.partnerName" placeholder="请输入" clearable></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="伙伴等级" prop="partnerLevelCode">
              <el-select v-model="queryForm.partnerLevelCode" placeholder="请选择" clearable>
                <el-option v-for="(value, key) in levelMap" :key="key" :label="value" :value="key"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="24" class="form-actions">
            <el-button type="primary" @click="handleQuery" :loading="queryLoading">
              查询
            </el-button>
            <el-button type="default" @click="handleReset" style="margin-left: 10px;">
              重置
            </el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <!-- 数据列表卡片（无标题） -->
    <el-card shadow="hover" class="table-card">
      <!-- 表格操作按钮 -->
      <div class="table-actions">
        <el-button type="primary" :icon="Plus" @click="openAddUserDialog">
          新增用户
        </el-button>
        <el-button type="success" :icon="OfficeBuilding" @click="openAddCompanyDialog" style="margin-left: 10px;">
          新增伙伴
        </el-button>
        <el-button type="danger" :icon="Delete" @click="handleDelete" style="margin-left: 10px;">
          删除
        </el-button>
      </div>

      <!-- 数据表格 -->
      <el-table :data="tableData" border stripe :loading="tableLoading" @selection-change="handleSelectionChange"
        style="width: 100%; margin-top: 10px; text-align: left;">
        <!-- 选择列：可保留固定宽度 -->
        <el-table-column type="selection" width="55"></el-table-column>

        <el-table-column label="用户昵称" min-width="120">
          <template #default="{ row }">
            <div class="cell-with-icon">
              <el-icon v-if="row.userType !== null" class="cell-with-icon-icon">
                <User />
              </el-icon>
              <span class="cell-with-icon-text" style="font-weight:800;">
                {{ row.userName }}
              </span>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="用户类型" min-width="120">
          <template #default="{ row }">
            {{ userTypeMap[row.userType] || row.userType }}
          </template>
        </el-table-column>

        <el-table-column label="伙伴名称/所属PMC" prop="name" min-width="150">
          <template #default="{ row }">
            <div class="cell-with-icon">
              <el-icon v-if="row.userType === null" class="cell-with-icon-icon">
                <OfficeBuilding />
              </el-icon>
              <span class="cell-with-icon-text">
                <span :style="row.userType === null ? 'font-weight:800;' : ''">
                  {{ row.name || PMCMap[row.affiliatedPMC] || row.affiliatedPMC }}
                </span>
              </span>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="伙伴类型" min-width="120">
          <template #default="{ row }">
            {{ partnerTypeMap[row.type] || row.type }}
          </template>
        </el-table-column>

        <el-table-column label="伙伴等级" min-width="120">
          <template #default="{ row }">
            {{ levelMap[row.level] || row.level }}
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页组件 -->
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        v-model:current-page="pagination.currentPage" v-model:page-size="pagination.pageSize"
        :page-sizes="[10, 20, 50, 100]" :total="pagination.total" layout="total, sizes, prev, pager, next, jumper"
        style="margin-top: 20px; display: flex; justify-content: flex-end;"></el-pagination>
    </el-card>

    <!-- 新增用户弹窗 -->
    <el-dialog title="新增用户" v-model="addUserDialogVisible" width="600px" :before-close="handleUserDialogClose">
      <el-form :model="addUserForm" :rules="addUserFormRules" ref="addUserFormRef" label-width="120px"
        class="dialog-form">
        <el-row :gutter="20">
          <!-- 用户类型 -->
          <el-col :span="24">
            <el-form-item label="用户类型" prop="userType">
              <el-select v-model="addUserForm.userType" placeholder="请选择" clearable @change="handleUserTypeChange">
                <el-option v-for="(value, key) in userTypeMap" :key="key" :label="value" :value="key"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <!-- 所属公司 -->
          <el-col :span="24">
            <el-form-item label="所属公司" prop="opPartnerId">
              <el-select v-model="addUserForm.opPartnerId" placeholder="请选择" clearable :disabled="!isCompanyEditable"
                :loading="companyListLoading" @visible-change="handleCompanyVisibleChange">
                <el-option v-for="item in companyList" :key="item.opPartnerId" :label="item.name"
                  :value="item.opPartnerId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <!-- 所属PMC -->
          <el-col :span="24">
            <el-form-item label="所属PMC" prop="PMC">
              <el-select v-model="addUserForm.affiliatedPMC" placeholder="请选择" clearable :disabled="!isPmcEditable">
                <el-option v-for="(value, key) in PMCMap" :key="key" :label="value" :value="key"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <!-- 用户名 -->
          <el-col :span="24">
            <el-form-item label="用户名" prop="userName">
              <el-input v-model="addUserForm.userName" placeholder="请输入" clearable
                @blur="handleUserNameBlur"></el-input>
            </el-form-item>
          </el-col>

          <!-- 新增手机号和邮箱展示 -->
          <el-col :span="24">
            <el-form-item label="手机号">
              <span v-if="loading">加载中...</span>
              <span v-else-if="phone">{{ phone }}</span>
              <span v-else style="font-size: 12px; color: #909399">未找到该用户</span>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="邮箱">
              <span v-if="loading">加载中...</span>
              <span v-else-if="email">{{ email }}</span>
              <span v-else style="font-size: 12px; color: #909399">未找到该用户</span>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <template v-slot:footer>
        <el-button @click="addUserDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSaveUser" :loading="saveUserLoading">
          保存
        </el-button>
      </template>
    </el-dialog>

    <!-- 新增伙伴弹窗 -->
    <el-dialog title="新增伙伴" v-model="addCompanyDialogVisible" width="600px" :before-close="handleCompanyDialogClose">
      <el-form :model="addCompanyForm" :rules="addCompanyFormRules" ref="addCompanyFormRef" label-width="120px"
        class="dialog-form">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="伙伴公司名称" prop="name">
              <el-input v-model="addCompanyForm.name" placeholder="请输入" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="伙伴类型" prop="partnerTypeCode">
              <el-select v-model="addCompanyForm.partnerTypeCode" placeholder="请选择" clearable>
                <el-option v-for="(value, key) in partnerTypeMap" :key="key" :label="value" :value="key"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="伙伴等级" prop="partnerLevelCode">
              <el-select v-model="addCompanyForm.partnerLevelCode" placeholder="请选择" clearable>
                <el-option v-for="(value, key) in levelMap" :key="key" :label="value" :value="key"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <template v-slot:footer>
        <el-button @click="addCompanyDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSaveCompany" :loading="saveCompanyLoading">
          保存
        </el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, reactive, computed, onMounted } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import axios from 'axios';
import { Plus, OfficeBuilding, Delete, User, SwitchButton, HomeFilled } from '@element-plus/icons-vue';
import { useRouter } from 'vue-router'
import openAtomApi from '@/openAtomApi';
import Cookies from 'js-cookie';


// 获取 router 实例
const router = useRouter()

// 定义方法
function goBack() {
  router.push('/demand-platform/home')
}

// 定义用户响应式数据
const user = reactive({
  login: '',
  id: null,
  name: ''
});

// 页面加载时进行权限校验
const authorize = async () => {
  try {
    const openAtomRes = await openAtomApi.get('/user/info');
    user.login = openAtomRes.data?.login;
    user.id = openAtomRes.data?.id;
    user.name = openAtomRes.data?.name;
    const res = await axios.post('/requestHeader/checkPermissions', null, {
      params: {
        userId: user.id,
        opRequestHeaderId: null,
        operationCode: 'LOCK',
      }
    });
    if (res.data.code !== 200) {
      throw new Error(res.data.desc);
    }
    if (!res.data.data) {
      router.push('/403');
    }
  } catch (error) {
    console.error(error);
    if (error.status === 403) {
      router.push('/403');
    } else {
      console.error('授权失败:', error);
      router.push('/500');
    }
  }
};

onMounted(() => {
  authorize();
});

// 退出登录
const handleLogout = () => {
  // localStorage.removeItem('accessToken');
  // localStorage.removeItem('refreshToken');
  Cookies.remove('accessToken', { path: '/' });
  Cookies.remove('refreshToken', { path: '/' });
  localStorage.removeItem('token_timestamp');
  // 跳转到登录页或调用登出 API
  router.push('/login');
  console.log('退出登录');
};


// ========== 响应式状态 ==========
const queryFormRef = ref(null);
const queryForm = reactive({});

const pagination = reactive({
  currentPage: 1,
  pageSize: 10,
  total: 0
});

const tableData = ref([]);       // 当前页数据
const fullTableData = ref([]);   // 全量原始数据
const selectedRows = ref([]);
const queryLoading = ref(false);
const tableLoading = ref(false);

// ========== 弹窗状态 ==========
const addUserDialogVisible = ref(false);
const addUserFormRef = ref(null);
const saveUserLoading = ref(false);
const addUserForm = reactive({
  userType: '',
  opPartnerId: '',
  affiliatedPMC: '',
  userName: '',
  userId: ''
});

const addCompanyDialogVisible = ref(false);
const addCompanyFormRef = ref(null);
const saveCompanyLoading = ref(false);
const addCompanyForm = reactive({
  name: '',
  partnerTypeCode: '',
  partnerLevelCode: ''
});
const addCompanyFormRules = reactive({
  name: [{ required: true, message: '请输入伙伴公司名称', trigger: 'blur' }],
  partnerTypeCode: [{ required: true, message: '请选择伙伴类型', trigger: 'change' }],
  partnerLevelCode: [{ required: true, message: '请选择伙伴等级', trigger: 'change' }]
});

// ========== 字典数据 ==========
const LANGUAGE = 'zh';
const PMCMap = reactive({});
const levelMap = reactive({});
const partnerTypeMap = reactive({});
const userTypeMap = reactive({});

// ========== 工具函数 ==========
async function fetchLookup(lookupType, targetMap) {
  try {
    const res = await axios.post('/requestHeader/queryLookup', null, {
      params: { lookupType, lookupCode: '', language: LANGUAGE }
    });
    if (res.data.code !== 200) throw new Error(res.data.desc || '未知错误');
    const list = res.data.data || [];
    list.forEach(item => {
      targetMap[item.lookupCode] = item.lookupValue;
    });
  } catch (error) {
    router.push('/500');
  }
}

fetchLookup('OP_PMC', PMCMap);
fetchLookup('OP_PARTNER_LEVEL', levelMap);
fetchLookup('OP_PARTNER_TYPE', partnerTypeMap);
fetchLookup('OP_USER_TYPE', userTypeMap);

// 添加状态管理
const companyList = ref([]);
const companyListLoading = ref(false);
const companyListLoaded = ref(false);

// 加载公司列表的方法
async function loadCompanyList() {
  companyListLoading.value = true;
  try {
    const res = await axios.get('/requestHeader/findPartnerCode');
    if (res.data.code !== 200) throw new Error(res.data.desc || '未知错误');
    companyList.value = Array.isArray(res.data.data) ? res.data.data : [];
    companyListLoaded.value = true;
  } catch (error) {
    ElMessage.error('加载公司列表失败:' + error);
  } finally {
    companyListLoading.value = false;
  }
}

// 处理下拉框展开/收起事件
function handleCompanyVisibleChange(visible) {
  if (visible && !companyListLoaded.value) {
    loadCompanyList();
  }
}

// ========== 核心：前端分页逻辑 ==========
function updatePageData() {
  const start = (pagination.currentPage - 1) * pagination.pageSize;
  const end = start + pagination.pageSize;
  tableData.value = fullTableData.value.slice(start, end);
  pagination.total = fullTableData.value.length;
}

async function handleQuery() {
  try {
    queryLoading.value = true;
    tableLoading.value = true;
    if (queryForm.partnerName === undefined) queryForm.partnerName = '';
    if (queryForm.userName === undefined) queryForm.userName = '';
    if (queryForm.PMC === undefined) queryForm.PMC = '';
    if (queryForm.partnerLevelCode === undefined) queryForm.partnerLevelCode = '';

    const hasPartnerFilter = (queryForm.partnerLevelCode !== '' || queryForm.partnerName !== '');
    const hasPmcFilter = (queryForm.PMC !== '');

    if (hasPartnerFilter && hasPmcFilter) {
      ElMessage.warning('伙伴等级/伙伴公司名称 与 所属PMC 不能同时作为查询条件，请调整后重试');
      return;
    }

    const requests = [];
    // 如果既没有 partner 也没有 pmc，则两个接口都要调用（合并结果）
    if (hasPmcFilter || (!hasPartnerFilter && !hasPmcFilter)) {
      requests.push(axios.get('/requestHeader/getPMCUserInfo', { params: { ...queryForm } }));
    }
    if (hasPartnerFilter || (!hasPartnerFilter && !hasPmcFilter)) {
      requests.push(axios.get('/requestHeader/getPartnerUserInfo', { params: { ...queryForm } }));
    }
    
    const responses = await Promise.all(requests);
    const merged = [];
    for (const res of responses) {
      if (res.data.code !== 200) throw new Error(res.data.desc || '未知错误');
      merged.push(...(res.data.data || []));
    }
    fullTableData.value = merged;
    pagination.currentPage = 1;
    updatePageData();
  } catch (error) {
    ElMessage.error('查询失败:' + error);
    console.error('查询失败:', error);
    fullTableData.value = [];
    tableData.value = [];
    pagination.total = 0;
  } finally {
    queryLoading.value = false;
    tableLoading.value = false;
  }
}

function handleReset() {
  if (queryFormRef.value) queryFormRef.value.resetFields();
  pagination.currentPage = 1;
  pagination.pageSize = 10;
  tableData.value = [];
  fullTableData.value = [];
  pagination.total = 0;
}

function handleSelectionChange(val) {
  selectedRows.value = val;
}

function handleSizeChange(val) {
  pagination.pageSize = val;
  pagination.currentPage = 1;
  updatePageData();
}

function handleCurrentChange(val) {
  pagination.currentPage = val;
  updatePageData();
}

// ========== 弹窗操作 ==========
function openAddUserDialog() {
  if (addUserFormRef.value) addUserFormRef.value.resetFields();
  Object.assign(addUserForm, { userType: '', opPartnerId: '', affiliatedPMC: '', userName: '' });
  addUserDialogVisible.value = true;
}

function openAddCompanyDialog() {
  if (addCompanyFormRef.value) addCompanyFormRef.value.resetFields();
  Object.assign(addCompanyForm, { name: '', partnerTypeCode: '', partnerLevelCode: '' });
  addCompanyDialogVisible.value = true;
}

async function handleSaveUser() {
  try {
    await addUserFormRef.value.validate();
    saveUserLoading.value = true;
    // const res = await axios.post('/requestHeader/addOrDeleteUser', addUserForm);
    if (addUserForm.userId === '') {
      throw new Error('未找到该用户，请确认用户名是否正确');
    }
    const res = await axios.post('/requestHeader/addOrDeleteUser', {
      opUserVOList: [addUserForm],
      operationCode: 'ADD',
    });
    if (res.data.code === 200) {
      ElMessage.success('用户新增成功');
      addUserDialogVisible.value = false;
      handleQuery(); // 重新加载全量数据
    } else {
      ElMessage.error(res.data.desc || '用户新增失败');
    }
  } catch (error) {
    if (error.name === 'ValidationError') {
      ElMessage.warning('请完善表单必填项');
    } else {
      ElMessage.error(error.toString() || '用户新增失败，请重试');
      console.error('新增用户失败:', error);
    }
  } finally {
    saveUserLoading.value = false;
  }
}

async function handleSaveCompany() {
  try {
    await addCompanyFormRef.value.validate();
    saveCompanyLoading.value = true;
    const res = await axios.get('/requestHeader/savePartner', { params: addCompanyForm });
    if (res.data.code === 200) {
      ElMessage.success('伙伴新增成功');
      addCompanyDialogVisible.value = false;
      handleQuery();
    } else {
      ElMessage.error('伙伴新增失败');
    }
  } catch (error) {
    if (error.name === 'ValidationError') {
      ElMessage.warning('请完善表单必填项');
    } else {
      ElMessage.error('伙伴新增失败，请重试');
      console.error('新增伙伴失败:', error);
    }
  } finally {
    saveCompanyLoading.value = false;
  }
}

async function handleDelete() {
  if (!selectedRows.value.length) {
    ElMessage.warning('请至少勾选一条数据');
    return;
  }

  try {
    await ElMessageBox.confirm('确定要删除选中的数据吗？', '删除确认', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    });

    const res = await axios.post('/requestHeader/addOrDeleteUser', {
      opUserVOList: selectedRows.value,
      operationCode: 'DELETE',
    });

    if (res.data.code === 200) {
      ElMessage.success('删除成功');
      handleQuery(); // 重新加载全量
      selectedRows.value = [];
    } else {
      ElMessage.error(res.data.desc || '删除失败');
    }
  } catch (error) {
    if (error !== 'cancel') {
      ElMessage.error(error.toString() || '删除失败，请重试');
      console.error('删除失败:', error);
    }
  }
}

// ========== 表单校验 ==========
// 添加计算属性控制可编辑状态
// 计算属性：动态控制字段状态
const isCompanyEditable = computed(() => addUserForm.userType === 'PARTNER');
const isPmcEditable = computed(() => addUserForm.userType === 'PMC');

// 核心修改：验证规则改为 blur 触发（仅在用户离开输入框时验证）
const addUserFormRules = {
  userType: [{ required: true, message: '请选择用户类型', trigger: 'change' }],
  opPartnerId: [
    { validator: validateCompany, trigger: 'blur' } // 关键：改为 blur 触发
  ],
  affiliatedPMC: [
    { validator: validatePmc, trigger: 'blur' } // 关键：改为 blur 触发
  ],
  userName: [{ required: true, message: '请输入用户名', trigger: 'blur' }]
};

// 验证逻辑（根据当前用户类型动态判断）
function validateCompany(rule, value, callback) {
  if (addUserForm.userType === 'PARTNER' && !value) {
    callback(new Error('所属公司必填'));
  } else {
    callback();
  }
}

function validatePmc(rule, value, callback) {
  if (addUserForm.userType === 'PMC' && !value) {
    callback(new Error('所属PMC必填'));
  } else {
    callback();
  }
}

function handleUserDialogClose() {
  if (addUserFormRef.value) addUserFormRef.value.resetFields();
  addUserDialogVisible.value = false;
  // 重置手机号和邮箱
  phone.value = '';
  email.value = '';
  loading.value = false;
}

function handleCompanyDialogClose() {
  if (addCompanyFormRef.value) addCompanyFormRef.value.resetFields();
  addCompanyDialogVisible.value = false;
}

// 添加状态管理
const phone = ref('');
const email = ref('');
const loading = ref(false);

// 优化处理函数
function handleUserTypeChange() {
  // 重置字段（不触发验证）
  addUserForm.opPartnerId = '';
  addUserForm.affiliatedPMC = '';
  loading.value = false;
}

function handleUserNameBlur() {
  if (addUserForm.userName) {
    fetchUserInfo(addUserForm.userName);
  } else {
    phone.value = '';
    email.value = '';
    loading.value = false;
  }
}

// 新增：获取用户信息API
async function fetchUserInfo(username) {
  loading.value = true;
  try {
    const response = await openAtomApi.get(`/users/${username}`);
    const userInfo = response.data || {};
    if (userInfo.id === undefined) throw new Error(userInfo.message || '未知错误');
    console.log('获取用户信息成功:', userInfo);
    phone.value = userInfo.phone || '无';
    email.value = userInfo.email || '无';
    addUserForm.userId = userInfo.id || '';
  } catch (error) {
    // API调用失败，保留"未找到该用户"状态
    console.error('获取用户信息失败:', error);
    phone.value = '';
    email.value = '';
  } finally {
    loading.value = false;
  }
}

</script>

<style scoped>
.data-query-page {
  padding: 20px;
  background-color: #f5f7fa;
  min-height: 100vh;
}

.page-header {
  margin-bottom: 20px;
}

.form-card,
.table-card {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.06);
  padding: 16px;
}

.form-card {
  margin-bottom: 12px;
}

.table-card {
  margin-top: 0 !important;
}

.card-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.query-form {
  margin-bottom: 16px;
}

.form-actions {
  display: flex;
  gap: 12px;
  margin-top: 16px;
}

.table-actions {
  display: flex;
  gap: 12px;
  margin-bottom: 16px;
  flex-wrap: wrap;
}

:deep(.el-table th),
:deep(.el-table td) {
  padding: 12px 8px;
}

:deep(.el-table .cell) {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dialog-form {
  padding: 10px 0;
}

@media (max-width: 1200px) {
  .el-col :deep(.el-form-item) {
    margin-bottom: 16px;
  }
}

@media (max-width: 768px) {
  .el-row {
    flex-direction: column;
  }

  .el-col {
    width: 100% !important;
    margin-bottom: 16px;
  }

  .query-form,
  .dialog-form {
    :deep(.el-form-item) {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
    }

    :deep(.el-form-item__label) {
      margin-bottom: 6px;
      text-align: left;
      width: auto !important;
    }

    :deep(.el-form-item__content) {
      width: 100% !important;
      margin-left: 0 !important;
    }
  }

  .form-actions,
  .table-actions {
    flex-direction: column;
    align-items: stretch;
  }

  .form-actions .el-button,
  .table-actions .el-button {
    width: 100%;
    margin-left: 0 !important;
    margin-bottom: 10px;
  }

  .form-card,
  .table-card {
    padding: 14px;
  }

  .card-title {
    font-size: 15px;
  }
}

.topbar {
  height: 60px;
  background-color: #fff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
  padding: 0 20px;
  display: flex;
  align-items: center;
}

.topbar-content {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.topbar-title {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.title-cn {
  font-weight: bold;
}

.divider {
  color: #999;
}

.title-en {
  color: #666;
  font-size: 14px;
}

.topbar-right {
  display: flex;
  align-items: center;
  gap: 12px;
}

.user-icon {
  font-size: 18px;
  color: #409eff;
}

.user-name {
  font-size: 14px;
  color: #555;
}

.logout-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 14px;
  color: #999;
  padding: 0;
  height: auto;
}

.logout-btn:hover {
  color: #f56c6c !important;
}

.cell-with-icon {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 1.4em;
}

.cell-with-icon-icon {
  font-size: 16px;
  display: flex;
  align-items: center;
}

.cell-with-icon-text {
  line-height: 1.2;
  display: inline-block;
}
</style>
